var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.4375H6.25C3.225 13.4375 1.5625 11.775 1.5625 8.75V6.25C1.5625 3.225 3.225 1.5625 6.25 1.5625H8.75C11.775 1.5625 13.4375 3.225 13.4375 6.25V8.75C13.4375 11.775 11.775 13.4375 8.75 13.4375ZM6.25 3.4375C4.275 3.4375 3.4375 4.275 3.4375 6.25V8.75C3.4375 10.725 4.275 11.5625 6.25 11.5625H8.75C10.725 11.5625 11.5625 10.725 11.5625 8.75V6.25C11.5625 4.275 10.725 3.4375 8.75 3.4375H6.25Z",
    fill: "url(#paint0_linear_833_7455)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13.4375H21.25C18.225 13.4375 16.5625 11.775 16.5625 8.75V6.25C16.5625 3.225 18.225 1.5625 21.25 1.5625H23.75C26.775 1.5625 28.4375 3.225 28.4375 6.25V8.75C28.4375 11.775 26.775 13.4375 23.75 13.4375ZM21.25 3.4375C19.275 3.4375 18.4375 4.275 18.4375 6.25V8.75C18.4375 10.725 19.275 11.5625 21.25 11.5625H23.75C25.725 11.5625 26.5625 10.725 26.5625 8.75V6.25C26.5625 4.275 25.725 3.4375 23.75 3.4375H21.25Z",
    fill: "url(#paint1_linear_833_7455)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 28.4375H21.25C18.225 28.4375 16.5625 26.775 16.5625 23.75V21.25C16.5625 18.225 18.225 16.5625 21.25 16.5625H23.75C26.775 16.5625 28.4375 18.225 28.4375 21.25V23.75C28.4375 26.775 26.775 28.4375 23.75 28.4375ZM21.25 18.4375C19.275 18.4375 18.4375 19.275 18.4375 21.25V23.75C18.4375 25.725 19.275 26.5625 21.25 26.5625H23.75C25.725 26.5625 26.5625 25.725 26.5625 23.75V21.25C26.5625 19.275 25.725 18.4375 23.75 18.4375H21.25Z",
    fill: "url(#paint2_linear_833_7455)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 28.4375H6.25C3.225 28.4375 1.5625 26.775 1.5625 23.75V21.25C1.5625 18.225 3.225 16.5625 6.25 16.5625H8.75C11.775 16.5625 13.4375 18.225 13.4375 21.25V23.75C13.4375 26.775 11.775 28.4375 8.75 28.4375ZM6.25 18.4375C4.275 18.4375 3.4375 19.275 3.4375 21.25V23.75C3.4375 25.725 4.275 26.5625 6.25 26.5625H8.75C10.725 26.5625 11.5625 25.725 11.5625 23.75V21.25C11.5625 19.275 10.725 18.4375 8.75 18.4375H6.25Z",
    fill: "url(#paint3_linear_833_7455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_833_7455",
    x1: 1.5625,
    y1: 6.93452,
    x2: 13.4375,
    y2: 6.93452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_833_7455",
    x1: 16.5625,
    y1: 6.93452,
    x2: 28.4375,
    y2: 6.93452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_833_7455",
    x1: 16.5625,
    y1: 21.9345,
    x2: 28.4375,
    y2: 21.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_833_7455",
    x1: 1.5625,
    y1: 21.9345,
    x2: 13.4375,
    y2: 21.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.650f3e5edbb442609f50ebcaa92a7a27.svg";
export { ForwardRef as ReactComponent };